const lodashGet = require('lodash.get');

class FlowTemplate {
  constructor(initObj) {
    Object.assign(this, initObj);
  }

}

FlowTemplate.fromJson = json => new FlowTemplate(json);

FlowTemplate.determineGenerator = flowTemplate => {
  if (lodashGet(flowTemplate, 'generator.template') === 'punchcard') {
    return {
      template: 'punchcard',
      input: {
        punches: lodashGet(flowTemplate, 'generator.input.punches')
      }
    };
  }

  return {
    template: 'default',
    input: {}
  };
};

module.exports = FlowTemplate;